var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/img/pdf-2.svg';
import _imports_1 from '../assets/img/excel-2.svg';
import _imports_2 from '../assets/img/docs-2.svg';
import _imports_3 from '../assets/img/text-2.svg';
import _imports_4 from '../assets/img/audio-2.svg';
import _imports_5 from '../assets/img/video-encoded.svg';
import _imports_6 from '../assets/img/video.svg';
import _imports_7 from '../assets/img/zip.svg';
const _withScopeId = n => (_pushScopeId("data-v-4698fa15"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "absolute flex flex-wrap file-encoding ml-1 top-3 left-2"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 1,
    class: "absolute flex flex-wrap file-encoding ml-1 top-2 left-2"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
    key: 0,
    class: "hover-option image-hover-media"
};
const _hoisted_8 = { class: "font-bold" };
const _hoisted_9 = {
    key: 0,
    class: "media-gradient h-full w-full absolute"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
    key: 2,
    src: _imports_0,
    alt: "",
    class: "absolute inset-0 w-14 h-14 m-auto"
};
const _hoisted_12 = {
    key: 3,
    src: _imports_1,
    class: "absolute inset-0 w-14 h-14 m-auto"
};
const _hoisted_13 = {
    key: 4,
    src: _imports_2,
    class: "absolute inset-0 w-14 h-14 m-auto"
};
const _hoisted_14 = {
    key: 5,
    src: _imports_3,
    class: "absolute inset-0 w-14 h-14 m-auto"
};
const _hoisted_15 = {
    key: 6,
    src: _imports_4,
    class: "absolute inset-0 w-14 h-14 m-auto"
};
const _hoisted_16 = {
    key: 7,
    src: _imports_5,
    class: "absolute inset-0 w-14 h-14 m-auto"
};
const _hoisted_17 = {
    key: 8,
    src: _imports_6,
    class: "absolute inset-0 w-14 h-14 m-auto"
};
const _hoisted_18 = {
    key: 9,
    src: _imports_7,
    class: "absolute inset-0 w-14 h-15 m-auto"
};
const _hoisted_19 = {
    key: 10,
    src: _imports_1,
    class: "absolute inset-0 w-14 h-15 m-auto"
};
const _hoisted_20 = { class: "h-full w-full absolute top-0" };
const _hoisted_21 = {
    key: 0,
    class: "media-file-name h-full"
};
const _hoisted_22 = {
    key: 1,
    class: /*#__PURE__*/ _normalizeClass(['absolute w-full top-0 bottom-0'])
};
const _hoisted_23 = { class: "file-name text-xs truncate font-bold text-white absolute bottom-4 left-2" };
const _hoisted_24 = {
    key: 0,
    class: "flex flex-wrap gap-3 mt-2"
};
import { DotsVerticalIcon, Download01Icon, FolderIcon, Link02Icon, TextInputIcon, Trash01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { renderIcon, UIButton, UIDropdown, UITag, UITextSmMedium, UITextXsRegular, UITooltip, } from '@gohighlevel/ghl-ui';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { truncate } from 'lodash';
import { computed, h, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import FailedWithTextIcon from '../assets/img/failed-expanded.svg';
import FailedIcon from '../assets/img/failed.svg';
import ProcessingWithTextIcon from '../assets/img/processing-expanded.svg';
import ProcessingIcon from '../assets/img/processing.svg';
import useEmitter from '../composable/useEmitter';
import { useEvent } from '../composable/useEvent';
import config from '../config';
import { useStore } from '../store';
import { MIME_TYPES } from '../util/const_helper';
import { copyToClipboard, downloadFile, formatBytes } from '../util/helper';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FileItem',
    props: {
        file: {},
        activeItem: {},
        disabled: { type: Boolean }
    },
    emits: ["onClickImage"],
    setup(__props, { emit: __emit }) {
        const emitter = useEmitter();
        const { t } = useI18n();
        const { sendNotification } = useEvent();
        dayjs.extend(relativeTime);
        const props = __props;
        const emit = __emit;
        const state = useStore();
        function timeFromNow(date) {
            return dayjs(date).fromNow();
        }
        const selfHosted = computed(() => {
            return state.selfHosted;
        });
        const contextMenuItems = [
            {
                icon() {
                    return h(renderIcon(Link02Icon), null, {});
                },
                label: t('common.getLink'),
                key: 'copy',
            },
            {
                icon() {
                    return h(renderIcon(FolderIcon), null, {});
                },
                label: t('common.moveToFolder'),
                key: 'move',
            },
            {
                icon() {
                    return h(renderIcon(TextInputIcon), null, {});
                },
                label: t('common.rename'),
                key: 'rename',
            },
            {
                icon() {
                    return h(renderIcon(Trash01Icon), null, {});
                },
                label: t('common.delete'),
                key: 'delete',
            },
        ];
        const hover = ref(false);
        const hoverDropdown = ref(false);
        const statusHover = ref(false);
        const getImageServerUrl = (image) => {
            var _a;
            try {
                const url = new URL(image);
                if ((_a = config.imageServerWhitelist) === null || _a === void 0 ? void 0 : _a.includes(url.hostname))
                    return `${config.imageServer}/image/f_webp/q_80/r_320/u_${image}`;
                else
                    return image;
            }
            catch (error) {
                console.error(error);
                return image;
            }
        };
        const isRaw = computed(() => {
            return props.file.isEncoded === undefined;
        });
        const isEncoded = computed(() => {
            return props.file.isEncoded;
        });
        const isError = computed(() => {
            if (!props.file.processingStartedAt)
                return false;
            const now = new Date();
            const processingStartedAt = new Date(props.file.processingStartedAt);
            const diffTime = Math.abs(now.getTime() - processingStartedAt.getTime());
            const diffDays = diffTime / (1000 * 60 * 60 * 24);
            return (props.file.isEncoded == false &&
                (diffDays >= 1 || props.file.encodingInProgress == false));
        });
        const onChangeOption = e => {
            hoverDropdown.value = false;
            switch (e) {
                case 'copy':
                    copyToClipboard(props.file.url);
                    sendNotification({
                        title: t('common.copiedClipboard'),
                        type: 'success',
                    });
                    break;
                case 'move':
                    emitter.emit('moveItem', props.file);
                    break;
                case 'rename':
                    emitter.emit('renameObject', props.file);
                    break;
                case 'delete':
                    emitter.emit('deleteFileFolder', {
                        id: props.file._id,
                        type: props.file.type,
                        name: props.file.name,
                    });
                    break;
                default:
                    break;
            }
        };
        const isProcessing = computed(() => {
            return props.file.isEncoded == false && props.file.encodingInProgress == true;
        });
        const showDownloadOption = computed(() => {
            return !state.mediaModal && (hover.value || hoverDropdown.value);
        });
        const toggleDropdown = e => {
            hoverDropdown.value = !hoverDropdown.value;
            e.stopPropagation();
        };
        const downloadMediaFile = () => __awaiter(this, void 0, void 0, function* () {
            sendNotification({
                title: t('common.downloading'),
                type: 'success',
            });
            const isDownloaded = yield downloadFile(props.file.url, props.file.name);
            if (!isDownloaded)
                sendNotification({
                    title: t('common.downloadFailed'),
                    type: 'error',
                });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["relative overflow-hidden bg-white rounded-lg shadow-xs group aspect-square ring-1 ring-black ring-opacity-5 h-full", {
                        'hover-effect': hover.value,
                    }]),
                onMouseenter: _cache[5] || (_cache[5] = ($event) => (hover.value = true)),
                onMouseleave: _cache[6] || (_cache[6] = ($event) => (hover.value = false))
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["relative overflow-hidden h-100 file-thumbnail", { 'bg-gray-100': _ctx.disabled, 'bg-gray-50': !_ctx.disabled }])
                }, [
                    _createElementVNode("div", {
                        onMouseenter: _cache[0] || (_cache[0] = ($event) => (statusHover.value = true)),
                        onMouseleave: _cache[1] || (_cache[1] = ($event) => (statusHover.value = false))
                    }, [
                        (selfHosted.value && !statusHover.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                (isProcessing.value)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _unref(ProcessingIcon),
                                        class: "inset-0 w-5 h-5"
                                    }, null, 8, _hoisted_2))
                                    : _createCommentVNode("", true),
                                (isError.value)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: _unref(FailedIcon),
                                        class: "inset-0 w-5 h-5"
                                    }, null, 8, _hoisted_3))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        (selfHosted.value && statusHover.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                (isProcessing.value)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _unref(ProcessingWithTextIcon),
                                        class: "inset-0 processing-hover-animation"
                                    }, null, 8, _hoisted_5))
                                    : _createCommentVNode("", true),
                                (isError.value)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: _unref(FailedWithTextIcon),
                                        class: "inset-0 failed-hover-animation"
                                    }, null, 8, _hoisted_6))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ], 32),
                    (hover.value || hoverDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (showDownloadOption.value)
                                ? (_openBlock(), _createBlock(_unref(UIButton), {
                                    key: 0,
                                    id: "media-file-download",
                                    type: "default",
                                    size: "small",
                                    disabled: false,
                                    loading: false,
                                    ghost: false,
                                    quaternary: true,
                                    circle: false,
                                    text: false,
                                    onClick: downloadMediaFile
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(Download01Icon), { class: "w-5 h-5 text-black cursor-pointer" })
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            _createVNode(_unref(UIDropdown), {
                                options: contextMenuItems,
                                id: "media-file-dropdown-menu",
                                placement: "bottom",
                                onClickoutside: _cache[2] || (_cache[2] = ($event) => (hoverDropdown.value = false)),
                                show: hoverDropdown.value,
                                onSelect: onChangeOption
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIButton), {
                                        id: "media-file-dropdown",
                                        type: "default",
                                        size: "small",
                                        disabled: false,
                                        loading: false,
                                        ghost: false,
                                        quaternary: true,
                                        circle: false,
                                        text: false,
                                        onClick: toggleDropdown
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(DotsVerticalIcon), { class: "w-5 h-5 text-black cursor-pointer" })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["show"])
                        ]))
                        : _createCommentVNode("", true),
                    (hover.value || hoverDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "hover-name text-white absolute bottom-4 left-2 image-hover-media",
                            onClick: _cache[3] || (_cache[3] = ($event) => (emit('onClickImage')))
                        }, [
                            _createVNode(_unref(UITooltip), null, {
                                trigger: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(truncate)(_ctx.file.name)), 1)
                                ]),
                                default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(_ctx.file.name), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(UITextXsRegular), null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(timeFromNow(_ctx.file.updatedAt)), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(UITextXsRegular), null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(formatBytes)(_ctx.file.size)), 1)
                                ]),
                                _: 1
                            })
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: _normalizeClass(["inset-0 w-full h-full overflow-hidden file-thumbnail-inner bg-gray-200", {
                                'opacity-40': _ctx.disabled,
                            }]),
                        onClick: _cache[4] || (_cache[4] = ($event) => (emit('onClickImage')))
                    }, [
                        (hover.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                            : _createCommentVNode("", true),
                        (_ctx.file.contentType.startsWith('image'))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: getImageServerUrl(_ctx.file.url),
                                alt: "",
                                class: "absolute inset-0 object-cover w-full h-full"
                            }, null, 8, _hoisted_10))
                            : (_unref(MIME_TYPES)['documents']['pdf'].includes(_ctx.file.contentType))
                                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                                : (_unref(MIME_TYPES)['documents']['excel'].includes(_ctx.file.contentType))
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                                    : (_unref(MIME_TYPES)['documents']['doc'].includes(_ctx.file.contentType))
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                                        : (_unref(MIME_TYPES)['documents']['text'].includes(_ctx.file.contentType))
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                                            : (_unref(MIME_TYPES)['audio'].includes(_ctx.file.contentType))
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                                                : (_unref(MIME_TYPES)['video'].includes(_ctx.file.contentType) &&
                                                    selfHosted.value &&
                                                    isEncoded.value)
                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                                                    : (_unref(MIME_TYPES)['video'].includes(_ctx.file.contentType))
                                                        ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                                                        : (_unref(MIME_TYPES)['zip'].includes(_ctx.file.contentType))
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                                                            : (_unref(MIME_TYPES)['documents']['csv'].includes(_ctx.file.contentType))
                                                                ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                                                                : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_20, [
                        (!hover.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                            : _createCommentVNode("", true),
                        (!hover.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createVNode(_unref(UITooltip), null, {
                                    trigger: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(truncate)(_ctx.file.name)), 1)
                                    ]),
                                    default: _withCtx(() => [
                                        _createTextVNode(" " + _toDisplayString(_ctx.file.name), 1)
                                    ]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ], 2),
                false
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["px-2 py-2 file-name-container", { 'bg-gray-50': _ctx.disabled, 'bg-white': !_ctx.disabled }])
                    }, [
                        _createElementVNode("div", null, [
                            _createVNode(_unref(UITextSmMedium), { class: "truncate text-black" }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UITooltip), null, {
                                        trigger: _withCtx(() => {
                                            var _a;
                                            return [
                                                _createTextVNode(_toDisplayString(_unref(truncate)((_a = _ctx.file) === null || _a === void 0 ? void 0 : _a.name)), 1)
                                            ];
                                        }),
                                        default: _withCtx(() => {
                                            var _a;
                                            return [
                                                _createTextVNode(_toDisplayString((_a = _ctx.file) === null || _a === void 0 ? void 0 : _a.name), 1)
                                            ];
                                        }),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(UITextXsRegular), { class: "text-black" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(timeFromNow(_ctx.file.createdAt)), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        (selfHosted.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                (isRaw.value)
                                    ? (_openBlock(), _createBlock(_unref(UITag), { key: 0 }, {
                                        default: _withCtx(() => [
                                            _createTextVNode("Raw")
                                        ]),
                                        _: 1
                                    }))
                                    : (isEncoded.value)
                                        ? (_openBlock(), _createBlock(_unref(UITag), {
                                            key: 1,
                                            type: "success"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("Encoded")
                                            ]),
                                            _: 1
                                        }))
                                        : (isError.value)
                                            ? (_openBlock(), _createBlock(_unref(UITag), {
                                                key: 2,
                                                type: "error"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("Failed")
                                                ]),
                                                _: 1
                                            }))
                                            : (isProcessing.value)
                                                ? (_openBlock(), _createBlock(_unref(UITag), {
                                                    key: 3,
                                                    type: "info"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode("Processing")
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ], 2))
                    : _createCommentVNode("", true)
            ], 34));
        };
    }
});
